import { Collection } from 'modules/core/lib/mobx-rest'

import { Action } from 'modules/automations/store/models/Action'

class ActionsCollection extends Collection<Action> {
  model() {
    return Action
  }

  // Returns a list of actions for an automations, ordered by ancestorship
  // Parent of action is pointed at by `automations_automation_id`
  // e.g. [5, 2 (son of 5), 3 (son of 2)]
  orderedListForAutomation(automationId: string | number): Action[] {
    const automationsForAction = this.filter({
      automations_automation_id: automationId,
    })

    // Find the action that has no parent, the root
    const first = automationsForAction.find(
      (automation) => !automation.get('automations_action_id')
    )

    if (!first) return []

    const findChild = (parent: Action) => {
      return automationsForAction.find(
        (automation) => automation.get('automations_action_id') === parent.get('id')
      )
    }

    const buildList = (element: Action): Action[] => {
      const child = findChild(element)

      if (child) return [element, ...buildList(child)]

      return [element]
    }

    return buildList(first)
  }
}

export const actions = new ActionsCollection()
